/** Position of the source image's top-left in stage CSS px, given current
 *  fit + viewport. Centers the image in the container, then applies pan. */
export function imageOrigin(
  containerW: number,
  containerH: number,
  imageW: number,
  imageH: number,
  scale: number,
  panX: number,
  panY: number,
): { x: number; y: number } {
  return {
    x: (containerW - imageW * scale) / 2 + panX,
    y: (containerH - imageH * scale) / 2 + panY,
  };
}
